import React, { type ComponentType, type PropsWithChildren } from 'react';

import type { HubDefaultParameters } from '@atlassian/company-hub-common/controllers/get-hub-default-parameters';
import type { ProductDependenciesProviderProps } from '@atlassian/company-hub-common/controllers/use-product-dependencies';
import {
	HubExtensionsWrapper,
	type HubExtensionsWrapperProps,
} from '@atlassian/company-hub-common/hub-extensions-wrapper';
import type { ExtensionMode, ExtensionParameters } from '@atlassian/company-hub-common/types';

import type { LinksMenuParameters } from '../../types';
import { extensionHasParams, LinksMenuContent } from './links-menu-content';

export type LinksMenuExtensionPropsProviderProps = PropsWithChildren<{
	mode: ExtensionMode;
}> &
	ExtensionParameters<LinksMenuParameters>;

export type LinksMenuExtensionProps = ExtensionParameters<LinksMenuParameters> & {
	propsProvider: ComponentType<ProductDependenciesProviderProps>;
} & Pick<LinksMenuExtensionPropsProviderProps, 'mode'> & {
		defaultParameters?: HubDefaultParameters;
	};

export const LinksMenuExtensionInner = ({
	extensionNode,
	contentId,
	mode,
}: HubExtensionsWrapperProps<LinksMenuParameters>): React.JSX.Element => {
	const { parameters } = extensionNode || {};
	return (
		<HubExtensionsWrapper<LinksMenuParameters>
			mode={mode}
			extensionNode={extensionNode}
			contentId={contentId}
			showNoDataState={!parameters}
			packageName="links-menu-extension"
		>
			{extensionNode && extensionHasParams(extensionNode) ? (
				<LinksMenuContent contentId={contentId} extensionNode={extensionNode} isInEditor />
			) : null}
		</HubExtensionsWrapper>
	);
};

export const LinksMenuExtension = ({
	propsProvider: PropsProvider,
	...props
}: LinksMenuExtensionProps): React.JSX.Element => (
	<PropsProvider {...props}>
		<LinksMenuExtensionInner {...props} />
	</PropsProvider>
);
